module.exports = __webpack_public_path__ + "img/copper11.70153539.gif";